import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { PackageFormState } from '@openx/types/package';
import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { useFilteredTargetingItems } from '../../../utils/hooks/useFilteredTargetingItems';
import { TargetingReadOnlyList } from './TargetingReadOnlyList';

type TargetingCriteriaProps = {
  pckg: PackageFormState;
};

export const TargetingCriteria = ({ pckg }: TargetingCriteriaProps): JSX.Element => {
  const { t } = useTranslation();
  const targeting = useFilteredTargetingItems(pckg);

  return (
    <FormSection divider title={t('Targeting Criteria')}>
      <TargetingReadOnlyList packageState={pckg} targeting={targeting} />
    </FormSection>
  );
};
